// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:55447ea9-7cc8-452c-9b1b-e77fa57b4973",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_ueE2zXUSQ",
    "aws_user_pools_web_client_id": "33l7noonn28gljnj6dpf1dtng3",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://4abbbl3lwrdzlnukvudasp5szy.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AWS_IAM",
    "aws_user_files_s3_bucket": "icam-lendinglibrary-productimages-production",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_content_delivery_bucket": "icam-lendinglibrary-20191205102512-hostingbucket-production",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d1iri2okj37qu.cloudfront.net"
};


export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js